export default {
  translation: {
    permission: {
      member: '成員',
      group: '群組',
      department: '部門',
      teamManagement: '團隊管理',
      membersInTotal: '總成員數',
      createGroup: '創建群組',
      leaveTheTeam: '離開團隊',
      owner: '所有者',
      moveDepartment: '部門轉移',
      manageMember: '管理成員',
      createSubDepartment: '創建子部門',
      description: '描述',
      descriptionPlaceholder: '請輸入描述',
      administrator: '管理者',
      setAsAdministrator: '設為管理者',
      transferOwner: '轉移所有權',
      permissionManagement: '權限管理',
      manage: '管理',
      collaborator: '協作者',
      team: '團隊',
      addCollaborator: '新增協作者',
      readPermission: '讀取權限',
      writePermission: '寫入權限',
      managePermission: '管理權限',
      ownerPermission: '所有者',
      manageCollaborator: '管理協作者',
      permission: '權限',
      transferTo: '轉移給',
      keepAdministratorPrivileges: '保留管理員權限',
      avatar: '頭像',
      deleteConfirmMessage: '{{id}} 正被 {{type}} 使用，如下所示',
      pleaseShareTheModelFirst: '請先分享以下知識庫或模型',
    },
  },
};
